module.exports = __webpack_public_path__ + "img/2_Edafologia.5a9eab0f.jpg";